import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import styles from './StatusCircle.module.css';
import { Popover } from '@material-ui/core';

const StatusCircle = ({
  color,
  hoverText,
  hoverAsSNText,
  hoverSerialText,
  hoverReasonText,
  hoverAgsnText,
  className,
  ...otherProps
}) => {
  const [isEllipsisPopupOpen, setIsEllipsisPopupOpen] = useState(false);
  const [ellipsisAnchorEl, setEllipsisAnchorEl] = useState(null);

  const handlePopoverOpen = event => {
    if (hoverText) {
      setIsEllipsisPopupOpen(true);
      setEllipsisAnchorEl(event.currentTarget);
    }
  };

  const handlePopoverClose = () => {
    setIsEllipsisPopupOpen(false);
    setEllipsisAnchorEl(null);
  };

  let colorClassName = styles.defaultCircle;

  if (color === 'red') colorClassName = styles.isRed;
  else if (color === 'green') colorClassName = styles.isGreen;
  else if (color === 'yellow') colorClassName = styles.isYellow;
  else if (color === 'blue') colorClassName = styles.isBlue;
  else if (color === 'white') colorClassName = styles.isWhite;

  return (
    <>
      <div
        className={clsx(styles.statusCircle, colorClassName, className)}
        onMouseEnter={e => handlePopoverOpen(e)}
        onMouseLeave={() => handlePopoverClose()}
        {...otherProps}
      />
      <Popover
        open={isEllipsisPopupOpen}
        anchorEl={ellipsisAnchorEl}
        onClose={handlePopoverClose}
        className={styles.popover}
        classes={{
          paper: styles.popoverPaper,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {hoverText}
        <br />
        {hoverAgsnText}
        <br />
        {hoverAsSNText}
        <br />
        {hoverSerialText}
        <br />
        {hoverReasonText}
      </Popover>
    </>
  );
};

StatusCircle.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

export default StatusCircle;
